import { combineReducers } from 'redux';
import { driverConfigurationReducer } from './driver-configurations/reducer';
import { driverMarginsReducer } from './driver-margins';

export const packagingDriverReducer = combineReducers({
  margins: driverMarginsReducer,
  configurations: driverConfigurationReducer,
});
